import { usergroupAPI } from '@/api';

export function lookForChangesInContact(original, current) {
  return (
    original.name === current.name &&
    original.email === current.email &&
    original.position === current.position &&
    original.phone_number === current.phone_number &&
    original.usergroup === current.usergroup_id
  );
}

export async function checkUsergroupJurisdiction(datasetCoverage, usergroupId, geoResource) {
  const usergroup = await usergroupAPI.getUsergroup(usergroupId);  
  const jurisdiction = usergroup && usergroup.organisation && usergroup.organisation.jurisdiction ?
    usergroup.organisation.jurisdiction :
    null;
  if (datasetCoverage && datasetCoverage.code === 2 && !jurisdiction) {
    return {
      jurisdictionCheck: false,
      jurisdictionError: 'noJurisdiction'
    };
  }
  if (datasetCoverage && datasetCoverage.code === 0 && !geoResource) {
    return {
      jurisdictionCheck: false,
      jurisdictionError: 'noGeoResource'
    };
  }
  return {
    jurisdictionCheck: true,
    jurisdictionError: null
  };
}